import { DateRangeInputNew } from '../components/forms/CalendarDateRangePicker';
import { FormGroup } from 'react-reactive-form';
import dayjs, { Dayjs } from 'dayjs';
import { DATE_FORMAT } from '../api/api.types';
import customParser from 'dayjs/plugin/customParseFormat';

export const dateOrderCorrect = (range: DateRangeInputNew, field?: string, form?: FormGroup,
                                 isDateTimePicker?: boolean): boolean => {
  let correct = true;
  if (range.startDate && range.endDate && (!!isDateTimePicker && range.startDate.isSame(range.endDate) ?
    false : !range.startDate?.isBefore(range.endDate))) {
    if (form && field) {
      form.controls[ `${field}From` ].setErrors({ 'incorrect': true });
      form.controls[ `${field}To` ].setErrors({ 'incorrect': true });
    }
    correct = false;
  }

  if (!range.startDate) {
    if (form && field) {
      form.controls[ `${field}From` ].setErrors({ 'incorrect': true });
    }
    correct = false;
  } else if (correct && form && field) {
    form.controls[ `${field}From` ].setErrors(null);
  }
  if (!range.endDate) {
    if (form && field) {
      form.controls[ `${field}To` ].setErrors({ 'incorrect': true });
    }
    correct = false;
  } else if (correct && form && field) {
    form.controls[ `${field}To` ].setErrors(null);
  }

  return correct;
};

export const dateTimeOrderCorrect = (dateTimeRange: {
  startDate?: Dayjs, endDate?: Dayjs, startTime?: string,
  endTime?: string
}, field?: string, form?: FormGroup): {
  startDateTime: string, endDateTime: string,
  error: boolean
} => {
  if (dateTimeRange.startDate && dateTimeRange.endDate && dateTimeRange.startTime && dateTimeRange.endTime) {
    const startDateTimeString = `${dateTimeRange.startDate.format(DATE_FORMAT)}T${dateTimeRange.startTime}`;
    const endDateTimeString = `${dateTimeRange.endDate.format(DATE_FORMAT)}T${dateTimeRange.endTime}`;
    const startDateTime = dayjs(startDateTimeString);
    const endDateTime = dayjs(endDateTimeString);
    if (startDateTime.isBefore(endDateTime)) {
      if (form && field) {
        form.controls[ `${field}FromTime` ].setErrors(null);
        form.controls[ `${field}ToTime` ].setErrors(null);
      }

      return {
        startDateTime: startDateTimeString,
        endDateTime: endDateTimeString,
        error: false
      };
    } else {
      if (form && field) {
        form.controls[ `${field}FromTime` ].setErrors({ 'incorrect': true });
        form.controls[ `${field}ToTime` ].setErrors({ 'incorrect': true });
      }

      return {
        startDateTime: '',
        endDateTime: '',
        error: true
      };
    }
  }

  let error = false;

  if (form && field) {
    if (form.submitted && !dateTimeRange.startTime) {
      form.controls[ `${field}FromTime` ].setErrors({ 'incorrect': true });
      error = true;
    } else if (form.submitted && dateTimeRange.startTime) {
      form.controls[ `${field}FromTime` ].setErrors(null);
    }
    if (form.submitted && !dateTimeRange.endTime) {
      form.controls[ `${field}ToTime` ].setErrors({ 'incorrect': true });
      error = true;
    } else if (form.submitted && dateTimeRange.endTime) {
      form.controls[ `${field}ToTime` ].setErrors(null);
    }
  } else {
    if (!dateTimeRange.startTime) {
      error = true;
    }
    if (!dateTimeRange.endTime) {
      error = true;
    }
  }

  return {
    startDateTime: '',
    endDateTime: '',
    error: error
  };
};

export const populateTimeSelect = () => {
  const times: { value: string; label: string }[] = [];
  for (let i = 0; i < 24; i += 1) {
    if (i < 10) {
      times.push({ value: (`0${String(i)}:00`), label: (`0${String(i)}:00`) });
      times.push({ value: (`0${String(i)}:30`), label: (`0${String(i)}:30`) });
    } else {
      times.push({ value: (`${String(i)}:00`), label: (`${String(i)}:00`) });
      times.push({ value: (`${String(i)}:30`), label: (`${String(i)}:30`) });
    }
  }

  return times;
};

export const isSameOrBefore = (date1: Dayjs, date2: Dayjs) => {
  return date1.isSame(date2) || date1.isBefore(date2);
};

export const formatDate = (dateString: string) => dayjs(new Date(dateString)).format('DD.MM.YYYY');
export const formatDateTime = (dateTimeString: string) => dayjs(new Date(dateTimeString)).format('DD.MM.YYYY HH:mm');
export const formatDateTimeWithSeconds = (dateTimeString: string) => dayjs(new Date(dateTimeString)).format('DD.MM.YYYY HH:mm:ss:ms');

dayjs.extend(customParser);
const dayJS = dayjs;
export default dayJS;
